import EmailReminderChangeType from 'owa-service/lib/contract/EmailReminderChangeType';
import InboxReminderType from 'owa-service/lib/contract/InboxReminderType';

export default function getFilteredInboxReminders(
    inboxReminders: InboxReminderType[]
): InboxReminderType[] {
    if (!inboxReminders) {
        // inbox reminders can be null for newly created compose event
        return [];
    }

    return inboxReminders.filter(reminder =>
        isOccurrenceChangeTypeSupported(reminder.OccurrenceChange)
    );
}

function isOccurrenceChangeTypeSupported(occurrenceChange: EmailReminderChangeType): boolean {
    return (
        occurrenceChange === EmailReminderChangeType.None ||
        occurrenceChange === EmailReminderChangeType.Added ||
        occurrenceChange === EmailReminderChangeType.Override
    );
}
